import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert , MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import ParticlesBg from 'particles-bg'
//import Login from './Login';
import Axios from 'axios'
//import { URL } from '../api';
import logo from './img/logokpru.png'
import { api, URL } from '../api';
import BrowserDetection from 'react-browser-detection';
import ReactResizeDetector from 'react-resize-detector';
//import publicIp from 'public-ip';
var md5 = require('md5');
var base64 = require('base-64');

const browserHandler = {
  chrome: () => <div>Chrome</div>,
  googlebot: () => <div>GoogleBot</div>,
  android: () => <div>Android</div>,
  ie: () => <div>ie</div>,
  edge: () => <div>edge</div>,
  safari: () => <div>safari</div>,
  default: (browser) => <div> {browser}</div>,
};


//import Swal from 'sweetalert2'

export default class Login extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,
                modalpdpa: false,
                admin_type:'',
                admin_typepdpa:'',
                encodedcitizen:'',
                url:'',
            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.getpdpa = this.getpdpa.bind(this);
            this.togglepdpa = this.togglepdpa.bind(this);
          }

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          togglepdpa = () => {
            this.setState({
              modalpdpa: !this.state.modalpdpa
            });
          }
        
          handleChange(event) {    this.setState({value: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }

          getpdpa() {



            setTimeout(() => {

              if (this.state.admin_type === 2) {
                 localStorage.setItem('admin_type', 2);
              } else if (this.state.admin_type === 3) {
                localStorage.setItem('admin_type', 3);
              } else if (this.state.admin_type === 4) {
                localStorage.setItem('admin_type', 4);
              } else if (this.state.admin_type === 5) {
                localStorage.setItem('admin_type', 5);
              } else if (this.state.admin_type === 6) {
                localStorage.setItem('admin_type', 6);
              } 

              window.location.href = 'https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code='+this.state.encodedcitizen+'&status='+this.state.admin_typepdpa+'&url='+this.state.url
               //ภายใน
              //   Axios.get('https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code='+this.state.encodedcitizen+'&status='+this.state.admin_typepdpa+'&url='+this.state.url)
              //  .then(res => {
              //    console.log(res);
              //  //  this.setState({ bankname: res.data, loading: false })
              //   // this.setState({ thschedule: res.data})
            
             
              //  }) 
             }, 0);
          }

          handleSubmit(event) {
            // alert('A name was submitted: ' + this.state.value);
             event.preventDefault();


        


            const Psaawordmd =  md5(this.state.Psaaword);
            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
            datafrm.append("txtemail", this.state.value);
            datafrm.append("txtpass", Psaawordmd);

            
            const user = {
              "txtemail": this.state.value,
              "txtpass": this.state.Psaaword
            };

              fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
                method: 'POST',
                body: JSON.stringify(user),
                headers: {
              
                }
              })
              .then(res => res.json())
                .then((res) => {
                    console.log(res);
                    if (res[0].loginstatus === "1" && res[0].employee_id === "000961" ) {
                      //  alert("เข้าสู่ระบบสำเร็จ")
                        localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
                      //  message.success("เข้าสู่ระบบสำเร็จ")
                        localStorage.setItem('loginstatus', res[0].loginstatus);
                        localStorage.setItem('Citizen_ID', res[0].employee_id);
                      //  localStorage.setItem('admin_type', 2);
                        localStorage.setItem('Univ_ID', 1);
                        localStorage.setItem('Univ_NAME', 'มหาวิทยาลัยราชภัฏกำแพงเพชร');
                    //   window.location.href = '/components/administrator/reportall'
                    // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
                    //  window.location.href = 'https://e-student.kpru.ac.th/grade/adminfaculty'

                                                                              Axios.get('https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue='+this.state.value+'&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR2AzlH362Dld2XOZhHJ9oN0u8pVKt0Yi1ONZzjeMRhqzz_FRHTi-wTFCzU')
                                                                              .then(res => {
                                                                                console.log(res);
                                                                              //  this.setState({ bankname: res.data, loading: false })
                                                                              // this.setState({ thschedule: res.data})
                                                                                if (res.data.length !== 0) {
                                                                                  localStorage.setItem('admin_type', 2);
                                                                              //    localStorage.setItem('admin_typepdpa', 2);
                                                                                  window.location.href = '/creditbank/Showadmin'
                                                                                } else {
                                                                                 this.setState({ admin_type: 2})
                                                                              //   this.setState({ admin_typepdpa: 2})
                                                                                  const encodedcitizen = base64.encode(this.state.value);
                                                                                  const admin_typepdpa = base64.encode(2);//บุคลากร
                                                                                  const url = base64.encode('https://e-student.kpru.ac.th/creditbank/Showadmin');
                                                                                  this.setState({ encodedcitizen: encodedcitizen})
                                                                                  this.setState({ admin_typepdpa: admin_typepdpa})
                                                                                  this.setState({ url: url})
                                                                               //   console.log(encodedcitizen)
                                                                               //   console.log(admin_typepdpa)
                                                                               //   console.log(url)
                                                                                  this.togglepdpa()   
                                                                                  
                                                                                }
                                                                              }) 





                  //  window.location.href = '/creditbank/Showadmin'
                    }else{
                     // console.log('f4f4f4');
                            //นักศึกษา
                           const Psaawordmd2 =  md5(this.state.Psaaword);
                            api.get('index/getuserstudent/'+this.state.value+'/'+Psaawordmd2,
                            {headers: {
                              // Authorization: 'Bearer ' + localStorage.getItem('myData')
                            }  })
                            .then(res => {

                              if (res.data.length !== 0 && res.data[0].Studentcb_Citizen_ID !== "" && this.state.value !== "") {
                                //  alert("เข้าสู่ระบบสำเร็จ")
                                  localStorage.setItem('name', res.data[0].Studentcb_NAME +"  "+ res.data[0].Studentcb_LASTNAME);
                                  message.success("เข้าสู่ระบบสำเร็จ")
                                  localStorage.setItem('loginstatus', '2');
                                  localStorage.setItem('type2', 1);//student_id Studentcb_ID
                                //  localStorage.setItem('admin_type', 3);
                                  localStorage.setItem('Univ_ID', 1);
                                  localStorage.setItem('Studentcb_ID', res.data[0].Studentcb_ID);
                                  localStorage.setItem('Univ_NAME', 'มหาวิทยาลัยราชภัฏกำแพงเพชร'); //รอระบุมหาวิทยาลัย
                             // window.location.href = '/creditbank/Studentmain'
                                                              Axios.get('https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue='+this.state.value+'&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR2AzlH362Dld2XOZhHJ9oN0u8pVKt0Yi1ONZzjeMRhqzz_FRHTi-wTFCzU')
                                                              .then(res => {
                                                                console.log(res);
                                                              //  this.setState({ bankname: res.data, loading: false })
                                                              // this.setState({ thschedule: res.data})
                                                                if (res.data.length !== 0) {
                                                                  localStorage.setItem('admin_type', 3);
                                                              //    localStorage.setItem('admin_typepdpa', 2);
                                                                  window.location.href = '/creditbank/Studentmain'
                                                                } else {
                                                                  this.setState({ admin_type: 3})
                                                              //   this.setState({ admin_typepdpa: 2})
                                                                  const encodedcitizen = base64.encode(this.state.value);
                                                                  const admin_typepdpa = base64.encode(3);
                                                                  const url = base64.encode('https://e-student.kpru.ac.th/creditbank/Studentmain');
                                                                  this.setState({ encodedcitizen: encodedcitizen})
                                                                  this.setState({ admin_typepdpa: admin_typepdpa})
                                                                  this.setState({ url: url})
                                                                //   console.log(encodedcitizen)
                                                                //   console.log(admin_typepdpa)
                                                                //   console.log(url)
                                                                  this.togglepdpa()   
                                                                  
                                                                }
                                                              }) 

                              }else{

                                                  //อาจารย์
                                                  const Psaawordmd3 =  this.state.Psaaword;
                                                  api.get('index/getuserteacherlogin/'+this.state.value+'/'+Psaawordmd3,
                                                  {headers: {
                                                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                                                  }  })    
                                                  .then(res => {      
                                                    if (res.data.length !== 0 && res.data[0].Teacher_Citizen_ID !== "" && this.state.value !== "") {

                                                                  localStorage.setItem('name', res.data[0].Teacher_NAME +"  "+ res.data[0].Teacher_LASTNAME);
                                                                  message.success("เข้าสู่ระบบสำเร็จ")
                                                                  localStorage.setItem('loginstatus', 'ok');
                                                                  localStorage.setItem('type2', 1);//student_id Studentcb_ID
                                                                 // localStorage.setItem('admin_type', 4);
                                                                  localStorage.setItem('Univ_ID', res.data[0].Univ_ID);
                                                                  localStorage.setItem('Citizen_ID', res.data[0].Teacher_Citizen_ID);
                                                                  localStorage.setItem('faculty', "0"+res.data[0].Teacher_faculty);
                                                                  localStorage.setItem('Univ_NAME', res.data[0].Univ_NAME); 

                                                                  //เจ้าหน้าที่หลักสูตร
                                                                  const Psaawordmd4 =  this.state.Psaaword;
                                                                  api.get('index/getAdminculogin1/'+this.state.value+'/'+Psaawordmd4,
                                                                  {headers: {
                                                                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                                                                  }  })    
                                                                  .then(res => { 
                                                                    if (res.data.length !== 0 && res.data[0].Admincu_Citizen_ID !== "" && this.state.value !== "") {
                
                                                                      localStorage.setItem('name', res.data[0].Admincu_NAME +"  "+ res.data[0].Admincu_LASTNAME);
                                                                     // message.success("เข้าสู่ระบบสำเร็จ")
                                                                      localStorage.setItem('loginstatus', 'ok');
                                                                      localStorage.setItem('type2', 1);//student_id Studentcb_ID
                                                                   //   localStorage.setItem('admin_type', 5);
                                                                      localStorage.setItem('Univ_ID', res.data[0].Univ_ID);
                                                                      localStorage.setItem('Citizen_ID', res.data[0].Admincu_Citizen_ID);
                                                                      localStorage.setItem('Univ_NAME', res.data[0].Univ_NAME); 
                
                                                                   //   window.location.href = '/creditbank/Teachermain'
                                                                                            Axios.get('https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue='+this.state.value+'&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR2AzlH362Dld2XOZhHJ9oN0u8pVKt0Yi1ONZzjeMRhqzz_FRHTi-wTFCzU')
                                                                                            .then(res => {
                                                                                              console.log(res);
                                                                                            //  this.setState({ bankname: res.data, loading: false })
                                                                                            // this.setState({ thschedule: res.data})
                                                                                              if (res.data.length !== 0) {
                                                                                                localStorage.setItem('admin_type', 5);
                                                                                            //    localStorage.setItem('admin_typepdpa', 2);
                                                                                                window.location.href = '/creditbank/Teachermain'
                                                                                              } else {
                                                                                                this.setState({ admin_type: 5})
                                                                                            //   this.setState({ admin_typepdpa: 2})
                                                                                                const encodedcitizen = base64.encode(this.state.value);
                                                                                                const admin_typepdpa = base64.encode(2);//อาจารย์
                                                                                                const url = base64.encode('https://e-student.kpru.ac.th/creditbank/Teachermain');
                                                                                                this.setState({ encodedcitizen: encodedcitizen})
                                                                                                this.setState({ admin_typepdpa: admin_typepdpa})
                                                                                                this.setState({ url: url})
                                                                                              //   console.log(encodedcitizen)
                                                                                              //   console.log(admin_typepdpa)
                                                                                              //   console.log(url)
                                                                                                this.togglepdpa()   
                                                                                                
                                                                                              }
                                                                                            }) 

                                                                     
                                                                     
                                                                    }else{

                                                                            const Psaawordmd5 =  this.state.Psaaword;
                                                                            api.get('index/getAdminAdmindean/'+this.state.value+'/'+Psaawordmd5,
                                                                            {headers: {
                                                                              // Authorization: 'Bearer ' + localStorage.getItem('myData')
                                                                            }  })    
                                                                            .then(res => { 
                                                                              if (res.data.length !== 0 && res.data[0].Admindean_Citizen_ID !== "" && this.state.value !== "") {
                                                                                    localStorage.setItem('name', res.data[0].Admindean_NAME +"  "+ res.data[0].Admindean_LASTNAME);
                                                                               //     message.success("เข้าสู่ระบบสำเร็จ")
                                                                                    localStorage.setItem('loginstatus', 'ok');
                                                                                    localStorage.setItem('type2', 1);//student_id Studentcb_ID
                                                                                 //   localStorage.setItem('admin_type', 6);
                                                                                    localStorage.setItem('Univ_ID', res.data[0].Univ_ID);
                                                                                    localStorage.setItem('Citizen_ID', res.data[0].Admindean_Citizen_ID);
                                                                                    localStorage.setItem('Univ_NAME', res.data[0].Univ_NAME); 
                              
                                                                                 //   window.location.href = '/creditbank/Admindeanmain'
                                                                                                                        Axios.get('https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue='+this.state.value+'&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR2AzlH362Dld2XOZhHJ9oN0u8pVKt0Yi1ONZzjeMRhqzz_FRHTi-wTFCzU')
                                                                                                                                .then(res => {
                                                                                                                                  console.log(res);
                                                                                                                                //  this.setState({ bankname: res.data, loading: false })
                                                                                                                                // this.setState({ thschedule: res.data})
                                                                                                                                  if (res.data.length !== 0) {
                                                                                                                                    localStorage.setItem('admin_type', 6);
                                                                                                                                //    localStorage.setItem('admin_typepdpa', 2);
                                                                                                                                    window.location.href = '/creditbank/Admindeanmain'
                                                                                                                                  } else {
                                                                                                                                    this.setState({ admin_type: 6})
                                                                                                                                //   this.setState({ admin_typepdpa: 2})
                                                                                                                                    const encodedcitizen = base64.encode(this.state.value);
                                                                                                                                    const admin_typepdpa = base64.encode(2);//อาจารย์
                                                                                                                                    const url = base64.encode('https://e-student.kpru.ac.th/creditbank/Admindeanmain');
                                                                                                                                    this.setState({ encodedcitizen: encodedcitizen})
                                                                                                                                    this.setState({ admin_typepdpa: admin_typepdpa})
                                                                                                                                    this.setState({ url: url})
                                                                                                                                  //   console.log(encodedcitizen)
                                                                                                                                  //   console.log(admin_typepdpa)
                                                                                                                                  //   console.log(url)
                                                                                                                                    this.togglepdpa()   
                                                                                                                                    
                                                                                                                                  }
                                                                                                                                }) 

                                                                              }else{

                                                                              //  window.location.href = '/creditbank/Teachermain'


                                                                                Axios.get('https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue='+this.state.value+'&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR2AzlH362Dld2XOZhHJ9oN0u8pVKt0Yi1ONZzjeMRhqzz_FRHTi-wTFCzU')
                                                                                .then(res => {
                                                                                  console.log(res);
                                                                                //  this.setState({ bankname: res.data, loading: false })
                                                                                // this.setState({ thschedule: res.data})
                                                                                  if (res.data.length !== 0) {
                                                                                    localStorage.setItem('admin_type', 4);
                                                                                //    localStorage.setItem('admin_typepdpa', 2);
                                                                                    window.location.href = '/creditbank/Teachermain'
                                                                                  } else {
                                                                                    this.setState({ admin_type: 4})
                                                                                //   this.setState({ admin_typepdpa: 2})
                                                                                    const encodedcitizen = base64.encode(this.state.value);
                                                                                    const admin_typepdpa = base64.encode(2);//อาจารย์
                                                                                    const url = base64.encode('https://e-student.kpru.ac.th/creditbank/Teachermain');
                                                                                    this.setState({ encodedcitizen: encodedcitizen})
                                                                                    this.setState({ admin_typepdpa: admin_typepdpa})
                                                                                    this.setState({ url: url})
                                                                                  //   console.log(encodedcitizen)
                                                                                  //   console.log(admin_typepdpa)
                                                                                  //   console.log(url)
                                                                                    this.togglepdpa()   
                                                                                    
                                                                                  }
                                                                                }) 


                                                                                        // Swal.fire({
                                                                                        //   title: 'ไม่สามารถเข้าถึงระบบได้!',
                                                                                        //   icon: 'error',
                                                                                        //   text: 'กรุณาลองอีกครั้ง',
                                                                                        // // showCancelButton: true,
                                                                                        //   confirmButtonText: 'ตกลง',
                                                                                        // // cancelButtonText: 'No, keep it'
                                                                                        // }).then((result) => {
                                                                                        // })
                                                                              }

                                                                            }) 
                
                                                                    }
                
                                                                  }) 


                                                    }else{

                                                        Swal.fire({
                                                          title: 'ไม่สามารถเข้าถึงระบบได้!',
                                                          icon: 'error',
                                                          text: 'กรุณาลองอีกครั้ง',
                                                        // showCancelButton: true,
                                                          confirmButtonText: 'ตกลง',
                                                        // cancelButtonText: 'No, keep it'
                                                        }).then((result) => {
                                                        
                                                        })

                                                    }

                                                  }) 

                              }

                              // console.log(res.data[0].id)
                              // console.log(res.data)
                              // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                              //  console.log(Course)
                               // const subdistrict = res.data;
                               // this.setState({ subdistrict });
                            }) 
                    



                      // message.error("เข้าสู่ระบบไม่สำเร็จ")
                      //  Swal.fire(
                      //   'ไม่สามารถเข้าถึงระบบได้',
                      //   'กรุณาลองอีกครั้ง',
                      //   'question'
                      // )
                      // window.location.href = '/'
                    }
                  
                })
                .catch(err => {
                  console.log('request failed', err);
                })
         

          }
      
        //   handleSubmit(event) {
        //     // alert('A name was submitted: ' + this.state.value);
        //      event.preventDefault();
        //     const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        //  datafrm.append("Username", this.state.value);
        //  datafrm.append("Psaaword", this.state.Psaaword);

        //  Axios
        //  // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
        //    .post("https://research.kpru.ac.th/culture/apiculture/selectadmin.php",datafrm)
        //    .then(res => {
        //      console.log("response: ", res)
        //      if (res.data.length !== 0) {
        //       // this.showitem = true;
        //        console.log(res)
        //        console.log(res.data.length)

        //        if (res.data[0].register_status === "1") {

        //         return this.setState({
        //           loading: true,
        //           // token_exp: +decodedEXP + "000"  //เก็บค่าหมดอายุของ token มาไว้ในตัวแปร
        //         }),
        //           //   localStorage.setItem('tokenExp', decodedEXP + "000"),
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           //   localStorage.setItem('profile', JSON.stringify(res.data[0]))
        //          // window.location.href = 'https://research.kpru.ac.th/culture/'
        //           window.location.href = '/adminfaculty'
    
        //       }
        //       else if (res.data[0].register_status === "2") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].Name),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
    
        //           // localStorage.setItem('picuser', data[0].picture);

        //           // window.location.href = 'https://research.kpru.ac.th/culture/superadmin'
        //           window.location.href = '/Timetable'


        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }
        //       else if (res.data[0].register_status === "3") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           localStorage.setItem('expert_id', res.data[0].id)
    
        //           // localStorage.setItem('picuser', data[0].picture);

        //          // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/expert'
        //          // window.location.href = '/expert'


        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }  else if (res.data[0].register_status === "4") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           localStorage.setItem('admin_faculty', res.data[0].register_faculty)
    
        //         // localStorage.setItem('picuser', data[0].picture);

        //         //  window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
        //         // window.location.href = '/adminfaculty'
        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }

        //      }else{
        //       this.setState({
        //         modal: true
               
        //     })
        //       // window.location.href = '/'
        //       // window.location.href = '/'
        //      }
        //      // do something about response
        //    })

        //   }


          // handleSubmit(event) {
          //   console.log(this.state.value)
          //   if (this.state.value === '1620600091565') {

           
          //     //  alert("เข้าสู่ระบบสำเร็จ")

          //       // localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
    
          //        message.success("เข้าสู่ระบบสำเร็จ")
          //        localStorage.setItem('nameuser', 'ชุลีพร')
          //        localStorage.setItem('admin_type', 4)
          //      //  localStorage.setItem('loginstatus', res[0].loginstatus);
          //     //   localStorage.setItem('type2', res[0].employee_id);
               
          //   //   window.location.href = '/components/administrator/reportall'
          //  // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
          //   window.location.href = '/tess/adminfaculty'
          //   }else{
          //      // message.error("เข้าสู่ระบบไม่สำเร็จ")
          //      Swal.fire(
          //       'ไม่สามารถเข้าถึงระบบได้',
          //       'กรุณาลองอีกครั้ง',
          //       'question'
          //     )
          //     //  window.location.href = '/'
          //   }
          // }



    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }

    render() {

      let config = {
        num: [4, 7],
        rps: 1,
        radius: [5, 40],
        life: [1.5, 3],
        v: [2, 3],
        tha: [-40, 40],
        // body: "./img/icon.png", // Whether to render pictures
        // rotate: [0, 20],
        alpha: [0.6, 0],
        scale: [1, 0.1],
        position: "center", // all or center or {x:1,y:1,width:100,height:100}
        color: ["random", "#ff0000"],
        cross: "dead", // cross or bround
        random: 15,  // or null,
        g: 5,    // gravity
        // f: [2, -1], // force
        onParticleUpdate: (ctx, particle) => {
            ctx.beginPath();
            ctx.rect(particle.p.x, particle.p.y, particle.radius * 2, particle.radius * 2);
            ctx.fillStyle = particle.color;
            ctx.fill();
            ctx.closePath();
        }
      };


    //  console.log(await publicIp.v4());
      
        return (
       
                <MDBContainer>
             <>
                {/* <div>...</div>  */}
                    {/* 
                    "color"
                    "ball"
                    "lines"
                    "thick"
                    "circle"
                    "cobweb"
                    "polygon"
                    "square"
                    "tadpole"
                    "fountain"
                    "random"
                    "custom" */}
                {/* <ParticlesBg type="cobweb" config={config} bg={true} /> */}
              </> 
              
              
                                   {/* <ReactResizeDetector handleWidth handleHeight>
                                       {({ width, height }) => <div>{`${width}x${height}`}</div>}
                               
                                    </ReactResizeDetector> */}


                    <MDBRow >
                    <MDBCol md="3">
                    </MDBCol>
                    
                        <MDBCol md="6">
                        <MDBCard >
                  
                            <div>
                            <MDBCardBody>
                            {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
                            <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/>
                          
                                      <form onSubmit={this.handleSubmit}>
                                          <p className="h3 text-center ">เข้าสู่ระบบ</p>
                                          <p className="h5 text-center ">ระบบคลังหน่วยกิต</p>
                                          {/* <p className="h5 text-center ">(สำหรับอาจารย์)</p> */}
                                          {/* <p className="h5 text-center "> ฝ่ายหลักสูตรและแผนการเรียน</p> */}
                                          <div className="grey-text">
                                          <MDBInput label="Username (เลขบัตรประจำตัวประชาชน)" icon="user" group type="text" validate error="wrong"
                                              success="right"  name="Username" value={this.state.value} onChange={this.handleChange}/>

                                          <MDBInput label="Password (ว/ด/ป เกิด)" icon="key" group type="password" validate error="wrong"
                                              success="right" value={this.state.Psaaword} onChange={this.handleChange2} />

                                          </div>
                                          <div className="text-center">
                                          <MDBBtn  color="blue darken-4" dark type="submit" value="Submit" >
                                          เข้าสู่ระบบ
                                              {/* <MDBIcon far icon="paper-plane" className="ml-1" /> */}
                                              <MDBIcon icon="hand-point-up" className="ml-1" />
                                          </MDBBtn>
                                          </div>
                                      </form>
                          {/* <Login/> */}
                           {/* {this.state.value}
                           {this.state.Psaaword} */}
                        </MDBCardBody> 
                        </div>

                        <br/>
                                     <MDBAlert color="primary" >
                                     <a href="#!" className="alert-link">อาจารย์</a>
                                     <p>Username = เลขประจำตัวประชาชน <br/>Password = ว/ด/ปี เกิด รูปแบบ 11012564 </p>
                                     {/* <p>Username = ว/ด/ปี เกิด รูปแบบ 110164</p> */}
                                    </MDBAlert>
                                    <MDBAlert color="success" >
                                     <a href="#!" className="alert-link">นักเรียน</a>
                                     <p>Username = เลขประจำตัวประชาชน <br/>Password = ว/ด/ปี เกิด รูปแบบ 11/01/64 </p>
                                     {/* <p>Username = ว/ด/ปี เกิด รูปแบบ 110164</p> */}
                                    </MDBAlert>

                                    </MDBCard>
                                    
                                    {/* <BrowserDetection>
                                      { browserHandler }
                                    </BrowserDetection> */}



                        </MDBCol>
                        
                        <MDBCol md="3">
                         
                        </MDBCol>
                    </MDBRow>

                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
        <MDBModalHeader toggle={this.toggle}>
        </MDBModalHeader>
        <MDBModalBody className="text-center">
         
        <MDBIcon icon="exclamation-circle" className="red-text text-center" size="5x" />
         <h3>usermame หรือ password ไม่ถูกต้อง</h3>
         <h3>กรุณาตรวจสอบความถูกต้อง อีกครั้ง!</h3>
        </MDBModalBody>
       
      </MDBModal>


      <MDBModal isOpen={this.state.modalpdpa} toggle={this.togglepdpa} size="lg" centered>
          <MDBModalHeader toggle={this.togglepdpa}>นโยบายข้อมูลส่วนบุคคล</MDBModalHeader>
          <MDBModalBody>
          <span style={{ fontSize: "16px" }}>  <a href="https://arit.kpru.ac.th/contents/Disclaimer/Disclaimer.pdf" target="_blank" >นโยบายข้อมูลส่วนบุคคล (PDPA) และข้อกำหนดในการให้บริการ</a>ของเรา <MDBBtn color="deep-purple" onClick={this.getpdpa}>ยอมรับ</MDBBtn></span>
          </MDBModalBody>
          <MDBModalFooter>
            {/* <MDBBtn color="secondary" onClick={this.togglepdpa}>Close</MDBBtn>
            <MDBBtn color="primary">Save changes</MDBBtn> */}
          </MDBModalFooter>
      </MDBModal>
                   
                    </MDBContainer>
                   
     
        )
    }
}
